export const resultArticles = [
    {
        id: 1,
        key: "Cocoa",
        title: "Cocoa",
        category: "article",
        content: {
            introduction: "Le cacao est une poudre et une boisson.",
            characteristics: "Le cacao est d'abord la poudre obtenu après la torréfaction et le broyage des fèves de cacao fermentées. Ces fèves poussent sur le cacaoyer.",
            usage: "La poudre de cacao sert à la préparation d'une boisson, le cacao.",
        },
        images: ["https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350", "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350", "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"]
    },
    {
        id: 2,
        key: "Cocoa",
        title: "Cocoa",
        category: "activity",
        content: {
            introduction: "Le cacao est une poudre et une boisson.",
            characteristics: "Le cacao est d'abord la poudre obtenu après la torréfaction et le broyage des fèves de cacao fermentées. Ces fèves poussent sur le cacaoyer.",
            usage: "La poudre de cacao sert à la préparation d'une boisson, le cacao.",
        },
        images: ["https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350", "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350", "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"]    
    },
    {
        id: 3,
        key: "Cocoa",
        title: "Cocoa",
        category: "dictionary",
        content: {
            introduction: "Le cacao est une poudre et une boisson.",
            characteristics: "Le cacao est d'abord la poudre obtenu après la torréfaction et le broyage des fèves de cacao fermentées. Ces fèves poussent sur le cacaoyer.",
            usage: "La poudre de cacao sert à la préparation d'une boisson, le cacao.",
        },
        images: ["https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350", "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350", "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350"]
    },
]